import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';

type BookingDialogFooterProps = {
  submitLabel: string;
  isPending: boolean;
  isSubmitDisabled?: boolean;
  destructiveLabel?: string;
  onDestructive?: () => void;
  onClose: () => void;
  onSubmit: () => void;
};

export const BookingDialogFooter = (props: BookingDialogFooterProps) => {
  const {
    submitLabel,
    isPending,
    isSubmitDisabled = false,
    destructiveLabel,
    onDestructive,
    onClose,
    onSubmit,
  } = props;
  const { t } = useTranslation();

  return (
    <DialogFooter className="gap-2 sm:justify-between">
      {!!destructiveLabel && !!onDestructive && (
        <Button
          variant="destructive"
          onClick={onDestructive}
          disabled={isPending}
        >
          {destructiveLabel}
        </Button>
      )}

      <div className="flex gap-2 sm:ml-auto">
        <Button
          variant="outline"
          onClick={onClose}
          disabled={isPending}
        >
          {t('Close')}
        </Button>
        <Button
          onClick={onSubmit}
          disabled={isPending || isSubmitDisabled}
        >
          {submitLabel}
        </Button>
      </div>
    </DialogFooter>
  );
};
